export type BmiDrawerMode =
    | 'over'
    | 'side';

export type BmiDrawerPosition =
    | 'left'
    | 'right';
